// ========== JasinChip 产品表格 — 多品牌智能搜索 v5 ==========
(function () {
  var viewport = document.querySelector('meta[name="viewport"]');
  if (viewport) {
    viewport.setAttribute('content', 'width=device-width, initial-scale=1.0');
  } else {
    var meta = document.createElement('meta');
    meta.name = 'viewport';
    meta.content = 'width=device-width, initial-scale=1.0';
    document.head.appendChild(meta);
  }
})();

// ========== 工具函数：种子随机数（千人千面） ==========
var PT = window.PT || {};
(function() {
  function getSessionSeed() {
    try {
      var stored = sessionStorage.getItem('_pt_seed_v3');
      if (!stored) {
        stored = String(Date.now()) + '_' + String(Math.floor(Math.random() * 999999));
        sessionStorage.setItem('_pt_seed_v3', stored);
      }
      return stored;
    } catch(e) { return String(Date.now()) + '_fallback'; }
  }
  var _baseSeed = getSessionSeed();
  function hashStr(s) { var h=0,i,c; for(i=0;i<s.length;i++){c=s.charCodeAt(i);h=((h<<5)-h)+c;h=h|0;} return Math.abs(h)||1; }
  function createRng(seed) { var s=hashStr(String(seed)); return function(){s=s+0x6D2B79F5|0;var t=Math.imul(s^s>>>15,1|s);t=t+Math.imul(t^t>>>7,61|t)^t;return((t^t>>>14)>>>0)/4294967296;}; }
  var _loadCount=0; try{_loadCount=parseInt(sessionStorage.getItem('_pt_load_count')||'0',10)||0;_loadCount++;sessionStorage.setItem('_pt_load_count',String(_loadCount));}catch(e){}
  var rng=createRng(_baseSeed+'_'+_loadCount);
  PT.nextRandom=function(){return rng();};
  PT.shuffle=function(arr){var a=arr.slice(),i=a.length,j,tmp;while(i){j=Math.floor(PT.nextRandom()*i);i--;tmp=a[i];a[i]=a[j];a[j]=tmp;}return a;};
})();

// ========== 主逻辑 ==========
(function() {
  function whenReady(fn) {
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', fn); }
    else { fn(); }
  }

  whenReady(function () {
    var searchInput = document.getElementById('part-number-search');
    var tbody = document.getElementById('search-results-body');
    if (!searchInput || !tbody) return;

    var TOKEN = '169f7c0caa2f5a5a2ffe5216a242a7a0';
    var API_URL = 'https://www.jasinchip.com.hk/api/2024-01/graphql.json';
    var COLLECTION_ID = 'gid://shopify/Collection/460393447640';

    // ========== 品牌数据库（全自动，无需手动维护） ==========
    var KNOWN_BRANDS = [];

    // 从 localStorage 恢复品牌记忆
    try {
      var savedBrands = localStorage.getItem('_pt_brands');
      if (savedBrands) {
        var parsed = JSON.parse(savedBrands);
        parsed.forEach(function(b) { if (b && b.length < 50) KNOWN_BRANDS.push(b); });
        console.log('[PT] 从浏览器记忆恢复 ' + KNOWN_BRANDS.length + ' 个品牌：' + KNOWN_BRANDS.join(', '));
      }
    } catch(e) {}

    // 保存品牌到 localStorage（永久记忆，跨会话保持）
    function saveBrands() {
      try {
        localStorage.setItem('_pt_brands', JSON.stringify(KNOWN_BRANDS));
      } catch(e) {}
    }

    // 发现新品牌 → 自动加入列表并保存
    function discoverBrand(name) {
      if (name && name.length > 0 && name.length < 50 && KNOWN_BRANDS.indexOf(name) === -1) {
        KNOWN_BRANDS.push(name);
        saveBrands();
        console.log('[PT] 自动发现新品牌：' + name + '（当前共 ' + KNOWN_BRANDS.length + ' 个）');
      }
    }

    // ========== API 查询 ==========
    function gqlFetch(query) {
      return fetch(API_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': TOKEN },
        body: JSON.stringify({ query: query })
      }).then(function(res) { return res.json(); });
    }

    function parseProducts(edges) {
      return edges.map(function(e) {
        var node = e.node;
        var metafields = node.metafields || [];
        var getMeta = function(key) {
          var f = metafields.find(function(m) { return m && m.key === key; });
          return f ? f.value : '';
        };
        return {
          id: node.id,
          url: '/products/' + node.handle,
          brand: getMeta('brand'),
          part_number: getMeta('part_number'),
          sku: (node.variants && node.variants.edges[0] && node.variants.edges[0].node.sku) || '',
          package_type: getMeta('package_type'),
          title: node.title || '',
          image: (node.featuredImage && node.featuredImage.url) || ''
        };
      });
    }

    function parseEmbeddedProducts(jsonData) {
      return jsonData.map(function(p) {
        return {
          id: p.id || '',
          url: '/products/' + (p.handle || ''),
          brand: p.brand || p.vendor || '',
          part_number: p.part_number || '',
          sku: '',
          package_type: p.package_type || '',
          title: p.title || '',
          vendor: p.vendor || '',
          image: p.featured_image || ''
        };
      });
    }

    // 构建单个品牌的产品搜索查询
    function makeBrandQuery(brand, count) {
      count = count || 3;
      return '{ products(first: ' + count + ', query: "collection_id:460393447640 AND title:' + brand + '*") { edges { node { id vendor handle title featuredImage { url } variants(first: 1) { edges { node { sku } } } metafields(identifiers: [{namespace: "custom", key: "brand"},{namespace: "custom", key: "package_type"},{namespace: "custom", key: "part_number"}]) { key value } } } } } }';
    }

    // 收集所有不重复品牌
    function collectAllBrands(products) {
      var seen = {};
      var brands = [];
      products.forEach(function(p) {
        var b = p.brand || '';
        if (b && !seen[b]) { seen[b] = true; brands.push(b); }
      });
      return brands;
    }

    // ========== 品牌均衡算法 ==========
    function getBalancedProducts(products, total) {
      if (!products || products.length === 0) return [];

      var brandMap = {};
      products.forEach(function(p) {
        var b = (p.brand && p.brand.trim()) ? p.brand.trim() : 'Other';
        if (!brandMap[b]) brandMap[b] = [];
        brandMap[b].push(p);
      });

      var allBrands = Object.keys(brandMap);
      allBrands.forEach(function(b) { brandMap[b] = PT.shuffle(brandMap[b]); });

      if (allBrands.length >= total) {
        var chosen = PT.shuffle(allBrands.slice()).slice(0, total);
        var result1 = [];
        chosen.forEach(function(b) { if (brandMap[b].length > 0) result1.push(brandMap[b][0]); });
        while (result1.length < total) {
          var leftover = PT.shuffle(allBrands.slice()).filter(function(b) { return brandMap[b].length > 0; });
          for (var i = 0; i < leftover.length && result1.length < total; i++) {
            var pool = brandMap[leftover[i]];
            result1.push(pool[Math.min(result1.filter(function(x) { return x.brand === leftover[i]; }).length, pool.length - 1)]);
          }
        }
        return PT.shuffle(result1).slice(0, total);
      }

      var numBrands = allBrands.length;
      var base = Math.floor(total / numBrands);
      var remainder = total % numBrands;
      var shuffledBrands = PT.shuffle(allBrands.slice());
      var extraSet = {};
      for (var i = 0; i < remainder; i++) { extraSet[shuffledBrands[i]] = true; }

      var result = [];
      allBrands.forEach(function(brand) {
        var count = base + (extraSet[brand] ? 1 : 0);
        var pool = brandMap[brand];
        for (var i = 0; i < count && i < pool.length; i++) { result.push(pool[i]); }
      });

      if (result.length < total) {
        var remaining = [];
        allBrands.forEach(function(brand) {
          var pool = brandMap[brand];
          var used = base + (extraSet[brand] ? 1 : 0);
          for (var i = used; i < pool.length; i++) { remaining.push(pool[i]); }
        });
        remaining = PT.shuffle(remaining);
        while (result.length < total && remaining.length > 0) { result.push(remaining.shift()); }
      }

      return PT.shuffle(result).slice(0, total);
    }

    // ========== 渲染表格行 ==========
    function renderResults(products, brandList) {
      if (products.length === 0) {
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 60px 20px; color: #999; font-size: 16px;">未找到匹配的产品</td></tr>';
        return;
      }

      var brands = brandList && brandList.length > 0 ? brandList : [];
      var brandCount = brands.length;

      var html = '';
      products.forEach(function (product, index) {
        var partNumber = product.part_number || '';
        var packageType = product.package_type || '';
        var url = product.url || '';
        var productImage = product.image || '';

        // 品牌列：优先用产品真实品牌，有品牌列表时可在各品牌产品间交错
        var displayBrand;
        if (brandCount > 0) {
          displayBrand = brands[index % brandCount];
        } else {
          displayBrand = product.brand || '';
        }

        // 产品缩略图（如果有图片的话）
        var imageHtml = '';
        if (productImage) {
          imageHtml = '<img class="product-thumb" src="' + productImage + '" alt="' + displayBrand + '" loading="lazy">';
        }

        html += '<tr class="product-row" data-product-id="' + product.id + '" data-product-url="' + url + '" data-real-brand="' + (product.brand || '') + '">'
          + '<td class="brand-cell" data-label="品牌">' + imageHtml + '<span class="cell-value">' + displayBrand + '</span></td>'
          + '<td class="part-number-cell clickable" data-label="型号"><span class="cell-value">' + partNumber + '</span></td>'
          + '<td class="package-cell" data-label="封装"><span class="cell-value">' + packageType + '</span></td>'
          + '<td class="input-cell year-cell" data-label="年份"><input type="text" class="pt-input year-input" data-field="year" inputmode="numeric"></td>'
          + '<td class="input-cell qty-cell" data-label="数量"><input type="number" class="pt-input qty-input" data-field="qty" min="1"></td>'
          + '<td class="input-cell price-cell" data-label="单价"><input type="text" class="pt-input price-input" data-field="price" inputmode="decimal"></td>'
          + '<td class="action-cell">'
          + '<button class="add-to-bom-btn" onclick="event.stopPropagation(); addToBOM(this)">BOM</button>'
          + '<button class="add-to-invoice-btn" onclick="event.stopPropagation(); addToInvoice(this)" data-brand="' + displayBrand + '" data-part-number="' + partNumber + '" data-package="' + packageType + '" data-product-id="' + product.id + '">Invoice</button>'
          + '</td>'
          + '</tr>';
      });

      tbody.innerHTML = html;
    }

    // ========== 多品牌产品发现引擎 ==========
    function discoverProductsAcrossBrands(brandList, callback) {
      var allEdges = [];
      var queries = [];

      // 1. 标准正向查询（快速返回，覆盖大部分）
      var fwdQuery = '{ collection(id: "' + COLLECTION_ID + '") { products(first: 50) { edges { node { id vendor handle title featuredImage { url } variants(first: 1) { edges { node { sku } } } metafields(identifiers: [{namespace: "custom", key: "brand"},{namespace: "custom", key: "package_type"},{namespace: "custom", key: "part_number"}]) { key value } } } } } }';
      queries.push(gqlFetch(fwdQuery));

      // 2. 反向查询（覆盖集合尾部品牌）
      var revQuery = '{ collection(id: "' + COLLECTION_ID + '") { products(first: 50, reverse: true) { edges { node { id vendor handle title featuredImage { url } metafields(identifiers: [{namespace: "custom", key: "brand"},{namespace: "custom", key: "package_type"},{namespace: "custom", key: "part_number"}]) { key value } } } } } }';
      queries.push(gqlFetch(revQuery));

      // 3. 对每个已知品牌逐个搜索，确保至少拿到该品牌的产品
      if (brandList && brandList.length > 0) {
        brandList.forEach(function(brand) {
          queries.push(gqlFetch(makeBrandQuery(brand, 3)));
        });
      }

      Promise.all(queries).then(function(results) {
        results.forEach(function(r) {
          // 从 collection 查询结果收集
          if (r && r.data && r.data.collection && r.data.collection.products) {
            var edges = r.data.collection.products.edges || [];
            allEdges = allEdges.concat(edges);
          }
          // 从 products 搜索查询结果收集
          if (r && r.data && r.data.products && r.data.products.edges) {
            var edges2 = r.data.products.edges || [];
            allEdges = allEdges.concat(edges2);
          }
        });

        // 去重
        var seen = {};
        var uniqueEdges = [];
        allEdges.forEach(function(e) {
          if (!seen[e.node.id]) { seen[e.node.id] = true; uniqueEdges.push(e); }
        });

        callback(uniqueEdges);
      }).catch(function() {
        callback([]);
      });
    }

    // ========== 主初始化 ==========
    function initProducts() {
      // 先尝试内嵌 JSON 秒开
      tryEmbeddedProducts().then(function(embeddedOk) {
        if (embeddedOk) return;

        // === API 多品牌发现 ===
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 40px; color: #999;">加载中...</td></tr>';

        discoverProductsAcrossBrands(KNOWN_BRANDS, function(edges) {
          if (edges.length === 0) {
            tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 60px 20px; color: #999;">请在上方输入料号开始搜索</td></tr>';
            return;
          }

          var products = parseProducts(edges);
          products.forEach(function(p) { discoverBrand(p.brand); });

          var allBrands = KNOWN_BRANDS.slice();
          console.log('[PT] 多品牌发现：' + edges.length + ' 产品，' + allBrands.length + ' 品牌：' + JSON.stringify(allBrands));

          var balanced = getBalancedProducts(products, 10);
          console.log('[PT] 展示品牌分布：' + balanced.map(function(p){return p.brand;}).join(', '));
          renderResults(balanced, allBrands);
        });
      });
    }

    // === 内嵌 JSON 快速渲染（秒开） ===
    function tryEmbeddedProducts() {
      return new Promise(function(resolve) {
        try {
          var embeddedEl = document.getElementById('initial-products-data');
          if (!embeddedEl) { resolve(false); return; }
          var raw = embeddedEl.textContent.trim();
          if (!raw) { resolve(false); return; }
          var embeddedData = JSON.parse(raw);
          if (!embeddedData || embeddedData.length === 0) { resolve(false); return; }

          console.log('[PT] 内嵌JSON，产品数：' + embeddedData.length);
          var products = parseEmbeddedProducts(embeddedData);

          // 从内嵌数据发现品牌
          products.forEach(function(p) { if (p.brand) discoverBrand(p.brand); });

          var allBrands = collectAllBrands(products);

          // 品牌不够 → 后台补充反向查询
          if (allBrands.length < KNOWN_BRANDS.length || allBrands.length <= 2) {
            console.log('[PT] 内嵌品牌 ' + allBrands.length + ' 个，后台补充查询...');
            var revQuery = '{ collection(id: "' + COLLECTION_ID + '") { products(first: 50, reverse: true) { edges { node { id vendor handle title featuredImage { url } metafields(identifiers: [{namespace: "custom", key: "brand"},{namespace: "custom", key: "package_type"},{namespace: "custom", key: "part_number"}]) { key value } } } } } }';
            gqlFetch(revQuery).then(function(revData) {
              var revEdges = (revData && revData.data && revData.data.collection && revData.data.collection.products && revData.data.collection.products.edges) || [];
              var newProducts = parseProducts(revEdges);
              newProducts.forEach(function(p) { if (p.brand) discoverBrand(p.brand); });
              var merged = allBrands.slice();
              collectAllBrands(newProducts).forEach(function(b) { if (merged.indexOf(b) === -1) merged.push(b); });
              if (merged.length > allBrands.length) {
                console.log('[PT] 合并后品牌=' + JSON.stringify(merged));
                // 重新取数据来渲染（用扩展后的品牌列表）
                discoverProductsAcrossBrands(merged, function(edges2) {
                  if (edges2.length > 0) {
                    var prods2 = parseProducts(edges2);
                    prods2.forEach(function(p) { if (p.brand) discoverBrand(p.brand); });
                    var brands2 = collectAllBrands(prods2);
                    renderResults(getBalancedProducts(prods2, 10), brands2);
                  }
                });
              }
            });
          }

          var balanced = getBalancedProducts(products, 10);
          console.log('[PT] 内嵌展示：' + balanced.map(function(p){return p.brand;}).join(', '));
          renderResults(balanced, allBrands);
          resolve(true); // 秒开完成
        } catch(e) {
          console.warn('[PT] 内嵌JSON解析失败', e);
          resolve(false);
        }
      });
    }

    // ========== 搜索逻辑 ==========
    var debounceTimer;

    searchInput.addEventListener('input', function (e) {
      var searchTerm = e.target.value.trim();
      clearTimeout(debounceTimer);

      if (searchTerm.length < 3) {
        tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 40px; color: #999;">请继续输入型号...</td></tr>';
        return;
      }

      debounceTimer = setTimeout(function () { fetchProducts(searchTerm); }, 300);
    });

    searchInput.addEventListener('keydown', function (e) {
      if (e.key === 'Enter') {
        clearTimeout(debounceTimer);
        var val = searchInput.value.trim();
        if (val.length >= 3) fetchProducts(val);
      }
    });

    searchInput.addEventListener('blur', function() {
      if (searchInput.value.trim().length === 0) { initProducts(); }
    });

    function fetchProducts(query) {
      tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 40px; color: #999;">搜索中...</td></tr>';

      var gqlQuery = '{ products(first: 250, query: "collection_id:460393447640 AND ' + query + '") { edges { node { id vendor handle title featuredImage { url } variants(first: 1) { edges { node { sku } } } metafields(identifiers: [{namespace: "custom", key: "brand"},{namespace: "custom", key: "package_type"},{namespace: "custom", key: "part_number"}]) { key value } } } } }';

      gqlFetch(gqlQuery)
        .then(function(data) {
          var edges = (data.data && data.data.products && data.data.products.edges) || [];
          var allProducts = parseProducts(edges);

          // 搜索过程中发现新品牌
          allProducts.forEach(function(p) { if (p.brand) discoverBrand(p.brand); });

          var q = query.toLowerCase();
          var filtered = allProducts.filter(function(p) {
            var pn = (p.part_number || '').toLowerCase();
            return pn.startsWith(q);
          });

          // 搜索结果的品牌分布
          var searchBrands = collectAllBrands(filtered);
          renderResults(filtered.slice(0, 10), searchBrands.length > 0 ? searchBrands : null);
        })
        .catch(function() {
          tbody.innerHTML = '<tr><td colspan="7" style="text-align:center; padding: 40px; color: #f00;">搜索失败，请重试</td></tr>';
        });
    }

    // ========== 产品图片缩放 ==========
    function setupImageZoom() {
      // 创建缩放浮层（如果还不存在）
      var overlay = document.getElementById('product-image-zoom');
      if (!overlay) {
        overlay = document.createElement('div');
        overlay.id = 'product-image-zoom';
        overlay.className = 'product-image-zoom-overlay';
        overlay.innerHTML = '<div class="product-image-zoom-container"><button class="product-image-zoom-close" aria-label="关闭">&times;</button><img class="product-image-zoom-img" src="" alt=""><span class="product-image-zoom-caption"></span></div>';
        document.body.appendChild(overlay);

        // 点击遮罩或关闭按钮 → 关闭
        overlay.addEventListener('click', function(e) {
          if (e.target === overlay || e.target.closest('.product-image-zoom-close')) {
            overlay.classList.remove('active');
            document.body.style.overflow = '';
          }
        });

        // ESC 关闭
        document.addEventListener('keydown', function(e) {
          if (e.key === 'Escape' && overlay.classList.contains('active')) {
            overlay.classList.remove('active');
            document.body.style.overflow = '';
          }
        });
      }

      // 委托点击缩略图 → 放大
      document.addEventListener('click', function(e) {
        var thumb = e.target.closest('.product-thumb');
        if (!thumb) return;
        e.stopPropagation();
        e.preventDefault();
        var img = overlay.querySelector('.product-image-zoom-img');
        var caption = overlay.querySelector('.product-image-zoom-caption');
        img.src = thumb.src;
        caption.textContent = thumb.alt || '';
        overlay.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    }
    setupImageZoom();

    // ========== 启动 ==========
    initProducts();
  });
})();
